import api from '.';
import { PaginationProps } from '../common/interface/pagination';

interface GetApprovalTypeParams extends PaginationProps {}

interface CreateApprovalType {
  name: string;
}

interface UpdateApprovalType extends CreateApprovalType {
  id: number | null;
}

export async function getApprovalTypes() {
  const { data } = await api.get('/approval-types');
  return data;
}

export async function getApprovalTypesMasterData(
  params: GetApprovalTypeParams
) {
  const { data } = await api.get('/approval-types/master-data', {
    params
  });
  return data;
}

export async function getApprovalType(id: number) {
  const { data } = await api.get(`/approval-types/${id}`);
  return data;
}

export async function createApprovalType(
  createApprovalType: CreateApprovalType
) {
  const { data } = await api.post('/approval-types', createApprovalType);
  return data;
}

export async function updateApprovalType(
  updateApprovalType: UpdateApprovalType
) {
  const { data } = await api.put(
    `/approval-types/${updateApprovalType.id}`,
    updateApprovalType
  );
  return data;
}

export function deleteApprovalType(id: number) {
  return api.delete(`/approval-types/${id}`);
}
